/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  MarkRiskResultsFalsePositiveRequestBody,
  MarkRiskResultsFalsePositiveRequestBody$Outbound,
  MarkRiskResultsFalsePositiveRequestBody$outboundSchema,
} from "../components/markriskresultsfalsepositiverequestbody.js";

export type MarkRiskResultsFalsePositiveSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type MarkRiskResultsFalsePositiveSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type MarkRiskResultsFalsePositiveSecurity = {
  option1?: MarkRiskResultsFalsePositiveSecurityOption1 | undefined;
  option2?: MarkRiskResultsFalsePositiveSecurityOption2 | undefined;
};

export type MarkRiskResultsFalsePositiveRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  markRiskResultsFalsePositiveRequestBody:
    MarkRiskResultsFalsePositiveRequestBody;
};

/** @internal */
export type MarkRiskResultsFalsePositiveSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const MarkRiskResultsFalsePositiveSecurityOption1$outboundSchema:
  z.ZodMiniType<
    MarkRiskResultsFalsePositiveSecurityOption1$Outbound,
    MarkRiskResultsFalsePositiveSecurityOption1
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function markRiskResultsFalsePositiveSecurityOption1ToJSON(
  markRiskResultsFalsePositiveSecurityOption1:
    MarkRiskResultsFalsePositiveSecurityOption1,
): string {
  return JSON.stringify(
    MarkRiskResultsFalsePositiveSecurityOption1$outboundSchema.parse(
      markRiskResultsFalsePositiveSecurityOption1,
    ),
  );
}

/** @internal */
export type MarkRiskResultsFalsePositiveSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const MarkRiskResultsFalsePositiveSecurityOption2$outboundSchema:
  z.ZodMiniType<
    MarkRiskResultsFalsePositiveSecurityOption2$Outbound,
    MarkRiskResultsFalsePositiveSecurityOption2
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function markRiskResultsFalsePositiveSecurityOption2ToJSON(
  markRiskResultsFalsePositiveSecurityOption2:
    MarkRiskResultsFalsePositiveSecurityOption2,
): string {
  return JSON.stringify(
    MarkRiskResultsFalsePositiveSecurityOption2$outboundSchema.parse(
      markRiskResultsFalsePositiveSecurityOption2,
    ),
  );
}

/** @internal */
export type MarkRiskResultsFalsePositiveSecurity$Outbound = {
  Option1?: MarkRiskResultsFalsePositiveSecurityOption1$Outbound | undefined;
  Option2?: MarkRiskResultsFalsePositiveSecurityOption2$Outbound | undefined;
};

/** @internal */
export const MarkRiskResultsFalsePositiveSecurity$outboundSchema: z.ZodMiniType<
  MarkRiskResultsFalsePositiveSecurity$Outbound,
  MarkRiskResultsFalsePositiveSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => MarkRiskResultsFalsePositiveSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => MarkRiskResultsFalsePositiveSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function markRiskResultsFalsePositiveSecurityToJSON(
  markRiskResultsFalsePositiveSecurity: MarkRiskResultsFalsePositiveSecurity,
): string {
  return JSON.stringify(
    MarkRiskResultsFalsePositiveSecurity$outboundSchema.parse(
      markRiskResultsFalsePositiveSecurity,
    ),
  );
}

/** @internal */
export type MarkRiskResultsFalsePositiveRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  MarkRiskResultsFalsePositiveRequestBody:
    MarkRiskResultsFalsePositiveRequestBody$Outbound;
};

/** @internal */
export const MarkRiskResultsFalsePositiveRequest$outboundSchema: z.ZodMiniType<
  MarkRiskResultsFalsePositiveRequest$Outbound,
  MarkRiskResultsFalsePositiveRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    markRiskResultsFalsePositiveRequestBody:
      MarkRiskResultsFalsePositiveRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      markRiskResultsFalsePositiveRequestBody:
        "MarkRiskResultsFalsePositiveRequestBody",
    });
  }),
);

export function markRiskResultsFalsePositiveRequestToJSON(
  markRiskResultsFalsePositiveRequest: MarkRiskResultsFalsePositiveRequest,
): string {
  return JSON.stringify(
    MarkRiskResultsFalsePositiveRequest$outboundSchema.parse(
      markRiskResultsFalsePositiveRequest,
    ),
  );
}
